export default __webpack_public_path__ + "static/media/arrow-right.608c8f00.svg";